import { diffWords } from '../utils/textDiff'
import clsx from 'clsx'

interface DiffViewerProps {
  original: string
  modified: string
  className?: string
}

export function DiffViewer({ original, modified, className }: DiffViewerProps) {
  const diff = diffWords(original, modified)

  return (
    <div className={clsx('font-mono text-sm leading-relaxed whitespace-pre-wrap', className)}>
      {diff.map((part, index) => {
        if (part.type === 'added') {
          return (
            <span
              key={index}
              className="bg-green-500/20 text-green-300 px-0.5 rounded"
              title="추가됨"
            >
              {part.value}
            </span>
          )
        } else if (part.type === 'removed') {
          return (
            <span
              key={index}
              className="bg-red-500/20 text-red-300 line-through px-0.5 rounded"
              title="삭제됨"
            >
              {part.value}
            </span>
          )
        } else {
          return <span key={index}>{part.value}</span>
        }
      })}
    </div>
  )
}
